// @ts-nocheck
import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ShoppingBag, Ticket, DollarSign } from "lucide-react";
import MembershipUpgradeAlert from "@/components/customer/MembershipUpgradeAlert";
import VideoOrders from "@/components/dashboard/VideoOrders";
import MyRegistrationsList from "@/components/billing/MyRegistrationsList";
import { useMyBilling, formatMoney } from "@/hooks/useMyBilling";

/**
 * Customer dashboard.
 *
 * Registrations and balances come from rle-list-my-billing (see useMyBilling),
 * which is the same balance computation the Stripe checkout uses.
 *
 * Removed: the spectator-ticket block that read event_registration_line_items.
 * That table does not exist on this project — the block could never render.
 * Spectator tickets live in event_ticket_purchases and have their own page.
 */
const CustomerDashboard: React.FC = () => {
  const { data } = useMyBilling();
  const summary = data?.summary;

  return (
    <div className="space-y-6">
      <MembershipUpgradeAlert />

      <div>
        <h1 className="text-2xl font-bold">My Dashboard</h1>
        <p className="text-muted-foreground">
          Your event registrations, balances and orders.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Registrations</CardTitle>
            <ShoppingBag className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{summary?.count ?? 0}</div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Outstanding</CardTitle>
            <DollarSign className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">
              {formatMoney(summary?.total_outstanding ?? 0)}
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Tickets</CardTitle>
            <Ticket className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <Button asChild variant="outline" size="sm">
              <Link to="/customer-dashboard/my-tickets">View my tickets</Link>
            </Button>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>My Registrations</CardTitle>
          <CardDescription>Balances shown here are what you will be charged.</CardDescription>
        </CardHeader>
        <CardContent>
          <MyRegistrationsList
            cancelPath="/customer-dashboard"
            emptyMessage="No event registrations yet."
          />
        </CardContent>
      </Card>

      <VideoOrders />
    </div>
  );
};

export default CustomerDashboard;
